/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Material Dashboard 2 React base styles
import colors from 'assets/theme/base/colors';

// Material Dashboard 2 React helper functions
import rgba from 'assets/theme/functions/rgba';
import pxToRem from 'assets/theme/functions/pxToRem';
import typography from 'assets/theme/base/typography';

const { dark, transparent, white } = colors;
const { size, fontWeightBold } = typography;

const divider = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      margin: `${pxToRem(16)} 0`,
      borderBottom: 'none'
    },

    fullWidth: {
      height: pxToRem(1),
      backgroundImage: `linear-gradient(to right, ${rgba(dark.main, 0)}, ${rgba(
        dark.main,
        0.4
      )}, ${rgba(dark.main, 0)}) !important`
    },

    withChildren: {
      margin: `${pxToRem(10)} 0`,
      '&:before, &:after': {
        borderTopColor: dark.main,
        borderTopWidth: 'medium'
      },
      '& .MuiDivider-wrapper': {
        fontSize: size.lg,
        fontWeight: fontWeightBold
      }
    },

    vertical: {
      backgroundColor: transparent.main,
      backgroundImage: `linear-gradient(to bottom, ${rgba(dark.main, 0)}, ${rgba(
        dark.main,
        0.4
      )}, ${rgba(dark.main, 0)}) !important`,
      width: pxToRem(1),
      height: '100%',
      margin: `0 ${pxToRem(16)}`,
      borderRight: 'none'
    },

    light: {
      backgroundColor: transparent.main,
      backgroundImage: `linear-gradient(to right, ${rgba(white.main, 0)}, ${white.main}, ${rgba(
        white.main,
        0
      )}) !important`,

      '&.MuiDivider-vertical': {
        backgroundImage: `linear-gradient(to bottom, ${rgba(white.main, 0)}, ${white.main}, ${rgba(
          white.main,
          0
        )}) !important`
      }
    }
  }
};

export default divider;
